<template>
	<q-list class="q-mb-md">
		<q-collapsible icon="fal fa-filter" v-model="open" @click="toggle" :label="getNameFilter">
			<div class="row gutter-sm" v-if="options">
				<div class="col-xs-12 col-sm-12" v-if="options.areas">
					<select-multiple
						label="areas"
						:filters="filters.area"
						:options="options.areas"
						@on_value="filters.area = $event"
					/>
				</div>

				<div class="col-xs-12 col-sm-12" v-if="options.profiles">
					<q-select
						v-model="filters.profile"
						chips
						:options="options.profiles"
						multiple
						:float-label="$t('profiles')"
						clearable
					/>
				</div>

				<div class="col-xs-12 col-sm-12" v-if="options.statuses">
					<q-select
						chips
						multiple
						v-model="filters.status"
						:options="options.statuses"
						:float-label="$t('status')"
						clearable
					/>
				</div>

				<div class="col-xs-12 col-sm-12" v-if="options.tags">
					<q-select
						chips
						multiple
						v-model="filters.tag"
						:options="options.tags"
						:float-label="$t('tags')"
						clearable
					/>
				</div>

				<div class="col-xs-12 col-sm-6 gutter">
					<q-datetime
						v-model="filters.start_date_display"
						:float-label="$t('creation_date_from')"
						type="datetime"
						format="DD/MM/YYYY HH:mm"
						clearable
					/>
				</div>

				<div class="col-xs-12 col-sm-6 gutter">
					<q-datetime
						v-model="filters.end_date_display"
						:float-label="$t('creation_date_to')"
						type="datetime"
						format="DD/MM/YYYY HH:mm"
						clearable
					/>
				</div>
			</div>
			<div class="row gutter-sm justify-end q-mt-sm">
				<div class="col-xs-12 col-sm-3">
					<q-btn
						color="negative"
						class="full-width"
						:label="$t('clear_filters')"
						icon="far fa-eraser"
						@click="clearFilter()"
					/>
				</div>
				<div class="col-xs-12 col-sm-3">
					<q-btn
						color="secondary"
						class="full-width"
						:label="$t('apply_filter_plural')"
						icon="far fa-filter"
						@click="requestFiltered()"
					/>
				</div>
			</div>
		</q-collapsible>
	</q-list>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
import SelectMultiple from 'components/utils/SelectMultiple'
const { formatDate } = date
export default {
	props: ['options'],
	data() {
		return {
			open: false,
			filters: {
				area: [],
				status: [],
				profile: [],
				tag: [],
				start_date_display: '',
				end_date_display: '',
				start_date: [],
				end_date: [],
			},
		}
	},

	components: {
		'select-multiple': SelectMultiple,
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			podcasts_filters: 'admin_filters/podcasts_filters',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getNameFilter() {
			if (Object.entries(this.filters).find((a) => a[1] && a[1].length > 0)) {
				return `${this.$t('filter')} <i class="far fa-exclamation-circle"></i>`
			} else return this.$t('filter')
		},
	},

	methods: {
		requestFiltered() {
			this.$emit('requestFiltered', {
				area: this.filters.area,
				profile: this.filters.profile,
				status: this.filters.status,
				tag: this.filters.tag,
				start_date: [
					date.formatDate(this.filters.start_date_display, 'YYYY-MM-DD-HH-mm-ss'),
				],
				end_date: [date.formatDate(this.filters.end_date_display, 'YYYY-MM-DD-HH-mm-ss')],
			})
			this.savePodcastsFilters()
			setTimeout(() => {
				this.toggle()
			}, 500)
		},

		clearFilter() {
			this.filters.area = []
			this.filters.status = []
			this.filters.profile = []
			this.filters.tag = []
			this.filters.start_date = []
			this.filters.start_date_display = ''
			this.filters.end_date = []
			this.filters.end_date_display = ''
			this.$emit('clearAndRequest')
			this.clearStoredFilters()
			setTimeout(() => {
				this.toggle()
			}, 500)
		},

		toggle() {
			this.open = !this.open
		},

		savePodcastsFilters() {
			this.$store.dispatch('admin_filters/SET_PODCASTS_FILTERS', {
				podcasts_filters: this.filters,
			})
		},

		loadPodcastsFilters() {
			this.filters = this.podcasts_filters
			setTimeout(() => {
				this.requestFiltered()
			}, 1000)
		},

		clearStoredFilters() {
			this.$store.dispatch('admin_filters/SET_PODCASTS_FILTERS', { podcasts_filters: {} })
		},
	},

	mounted() {
		if (this.podcasts_filters && this.podcasts_filters.status) {
			this.loadPodcastsFilters()
		}
	},
}
</script>

<style></style>
